module.exports = __webpack_public_path__ + "img/footer.58268c19.jpg";